/** 
 * Informações das colunas para listagem de faixas de imposto
 * @type {Array<{
 *   label: string,
 *   name: string,
 *   width: string | number,
 *   colSpan: string | number,
 *   className: string,
 *   style: string
 * }>} 
 */
export const columns = [
    {
        label: 'Épico',
        name: 'epico',
        width: '15%'
    },
    {
        label: 'Issue',
        name: 'issueKey',
        width: '40%'
    },
    {
        label: 'Colaborador',
        name: 'author',
        width: '20%'
    },
    {
        label: 'Horas',
        name: 'timeLogged',
        width: '10%'
    },
    {
        label: 'Valor',
        name: 'valor',
        width: '15%'
    }
];


const IssuesListInfo = { columns };

export default IssuesListInfo;